import {
  useState
} from 'react'
import {
  FeatureFlags,
} from '../../analytics/posthog'
import {
  type ExperimentAssignment,
  useFirstPaintArm,
} from '../../hooks/useFirstPaintArm'

// Tailwind's `sm` breakpoint: below it the picker is the two-column phone grid
// the redesign is for. Wider screens keep the current picker and never enrol.
export const MOBILE_PICKER_MEDIA_QUERY = '(max-width: 639px)'

function isPhoneWidth(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return window.matchMedia(MOBILE_PICKER_MEDIA_QUERY).matches
}

// The mobile assistant-picker experiment (GET-20066), decided on first paint
// like the permissions-copy one so a slow PostHog shows the current picker
// rather than a spinner. Only phone-width visitors are eligible.
export function useMobilePickerArm(): ExperimentAssignment {
  const [phoneWidth] = useState(isPhoneWidth)
  return useFirstPaintArm(FeatureFlags.MOBILE_ASSISTANT_PICKER, phoneWidth)
}
